import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Course } from 'src/app/models/course.model';
import { CourseService } from 'src/app/services/course.service';
import { ErrorService } from 'src/app/services/error.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs/operators';
import { Lesson } from 'src/app/models/lesson.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CoursePass } from 'src/app/models/course-pass.model';
import { ToastrService } from 'ngx-toastr';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Comment } from 'src/app/models/comment.model';
import { Subject } from 'rxjs';

import { Inject }  from '@angular/core';
import { DOCUMENT } from '@angular/common'; 
import { Question } from 'src/app/models/question.model';

@Component({
  selector: 'app-my-course',
  templateUrl: './my-course.component.html',
  styleUrls: ['./my-course.component.css']
})
export class MyCourseComponent implements OnInit {

  public showSpinner: boolean;

  showQuizDialog: boolean = false

  course: Course = new Course();

  lessons: Lesson[] = [];

  currentLesson: Lesson = new Lesson();

  videoUrl: string = '';

  isPause: boolean = false;

  public htmlContent: string;

  public instruction: string;

  isPostingComment: boolean = false;

  comments: Comment[] = [];

  coursePass: CoursePass;

  showScoreResult:boolean = false

  resultScore:number = 0

  hideDesc:boolean = false

  lessonId$ = new Subject<string>();

  videoOption = { autoplay: false, fluid: true, controls: true, sources: [{ src: this.videoUrl, type: 'video/mp4' }] };

  cloneQuestions:Question[] = [];

  constructor(
    private route: ActivatedRoute,
    private courseService: CourseService,
    private errorService: ErrorService,
    private router: Router,
    private toastr: ToastrService,
    private firestore: AngularFirestore,
    @Inject(DOCUMENT) document: Document
  ) {
  

    const queryObservable = this.lessonId$.pipe(
      switchMap(id =>
        this.firestore.collection('comments', ref => ref.where('lessonId', '==', id)).snapshotChanges()
      )

    );

    queryObservable.subscribe(snapshot => {

      var comments = snapshot.map(function (item) {
        var comment = item.payload.doc.data() as Comment;
        const id = item.payload.doc.id;
        comment.id = id;
        return comment;
      })

      this.comments = comments;


    });




  }
  ngOnInit(): void {
    this.route.data
      .subscribe((data: { coursePass: CoursePass }) => {
        this.coursePass = data.coursePass;
      });
    if (!this.coursePass.passCheck) {
      // Redirect to 404
      this.router.navigate(['not-found']);
    }
    console.log(this.coursePass)
    this.getCourse();
    this.getLessons();

    const videoJs = document.getElementById('my-player_html5_api') as HTMLElement;
    console.log("VCss:"+videoJs.style.width)
  }

  getCourse() {
    let id = this.route.snapshot.params['id'];
    //this.showSpinner = true;
    this.courseService.findOne(id)
      .pipe(
        catchError(this.errorService.handle)
      )
      .subscribe(
        result => {
          this.showSpinner = false;
          this.course = result;
          console.log("Course", this.course)
        },
        error => {
          this.showSpinner = false;
          console.log(error);
        }
      )
  }

  getLessons() {
    let id = this.route.snapshot.params['id'];
    this.showSpinner = true;
    this.courseService.getLessons(id)
      .pipe(
        catchError(this.errorService.handle)
      )
      .subscribe(
        result => {
          console.log(result);
          this.lessons = result;
          this.lessons.forEach(lesson => {
            if (this.coursePass.watchedLessons.includes(lesson.id)) {
              lesson. disable= false
            } else {
              lesson.disable = true
            }
          });

          if (this.lessons.length > 0) {
            this.lessons[0].disable = false;
            this.currentLesson = this.lessons[0];
            this.lessonId$.next(this.currentLesson.id)
            this.instruction = this.lessons[0].instruction
          }
          this.showSpinner = false;
          console.log("Current Lesson" + this.currentLesson.videoUrl);
        },
        error => {
          this.showSpinner = false;
          console.log(error);
        }
      )
  }

  chooseLesson(lesson: Lesson) {
    // window.scroll(0,300)
    console.log("Choose Lesson");

    this.htmlContent = lesson.descriptionEn;
    this.instruction = lesson.instruction;
    this.currentLesson = {...lesson};

    if (lesson.quiz){
      this.cloneQuestions = [...lesson.quiz];
    }

    this.lessonId$.next(lesson.id)
    this.addWatchedLesson();
    if (lesson.videoUrl === '') {
      this.isPause = true;
    }
  }

  addWatchedLesson() {
    let courseId = this.route.snapshot.params['id'];
    if (this.coursePass.watchedLessons.includes(this.currentLesson.id)) {
      // Already in list
      this.enableNextVideo();
      return;
    }
    this.coursePass.watchedLessons.push(this.currentLesson.id)
    this.courseService.addWatchedLesson(courseId, this.currentLesson.id)
      .pipe(
        catchError(this.errorService.handle)
      )
      .subscribe(
        result => {
          this.enableNextVideo();
        }
      )
  }

  onPlay(status: boolean) {
    console.log("on play");
    this.addWatchedLesson();
  }

  onPostComment(text: string) {
    this.isPostingComment = true;
    let courseId = this.route.snapshot.params['id'];
    let lessonId = this.currentLesson.id;
    this.courseService.addComment(courseId,lessonId, text)
      .pipe(
        catchError(this.errorService.handle)
      )
      .subscribe(
        result => {
          console.log(result);
          this.toastr.success("Posted Comment Successfully");
          this.isPostingComment = false;
        },
        error => {
          this.toastr.error("Transaction failed");
          this.isPostingComment = false;
        }

      )
  }

  enableNextVideo() {
    const nextIndex = this.lessons.findIndex((lessson) => lessson.id === this.currentLesson.id);
    console.log("Next Index" + nextIndex);
  
    
    if (nextIndex !== -1 && nextIndex < this.lessons.length - 1) {

      const isHaveQuiz = this.currentLesson.quiz && this.currentLesson.quiz.length > 0
      const isSubmittedZuiz = this.coursePass.submittedQuizLesson.includes(this.currentLesson.id)
      
      console.log(isHaveQuiz);
      console.log(isSubmittedZuiz);

      if(isSubmittedZuiz){
        if (this.currentLesson.videoUrl == ''){
          this.lessons[nextIndex + 1].disable = false;
        }else{
          if (this.coursePass.watchedLessons.includes(this.currentLesson.id)){
            this.lessons[nextIndex + 1].disable = false;
          }
        }
        
      }else if(!isHaveQuiz){
        if (this.currentLesson.videoUrl == ''){
          this.lessons[nextIndex + 1].disable = false;
        }else{
          if (this.coursePass.watchedLessons.includes(this.currentLesson.id)){
            this.lessons[nextIndex + 1].disable = false;
          }
        }
      }

      // if(this.currentLesson.quiz && this.currentLesson.quiz.length > 0){
      //   // Have Quiz

      // }else{
      //   // No Quiz
      //   this.lessons[nextIndex + 1].disable = false;
      // }

      // // Found 
      // if(this.coursePass.submittedQuizLesson.includes(this.currentLesson.id)){
      //   // Ever submit Quiz
      //   this.lessons[nextIndex + 1].disable = false;
      // }else if(this.currentLesson.quiz && this.currentLesson.quiz.length === 0){
      //   this.lessons[nextIndex + 1].disable = false;
      // }else if(this.currentLesson.videoUrl === '' && !this.currentLesson.quiz){
      //   // Have Quiz
      //   this.lessons[nextIndex + 1].disable = false;
      // }else if(this.currentLesson.videoUrl === '' && this.currentLesson.quiz && this.currentLesson.quiz.length === 0){
      //   this.lessons[nextIndex + 1].disable = false;
      // }
    }
  }

  setSeletedClass(lesson: Lesson) {
    const conditions = lesson.disable;
    const classes = {
      'selected': lesson.id === this.currentLesson.id ? true : false,
      'disabled-link': conditions
    }
    return classes;
  }

  setVideoClasses(lesson: Lesson) {
    const conditions = lesson.videoUrl === '';
    const classes = {
      'hidden': conditions
    }
    return classes;
  }

  setDescClasses(){
    const classes = {
      'courses-details-desc':true,
      'hidden':this.hideDesc
    }
    return classes;
  }

  onShowQuiz() {
    console.log('show quiz');
    this.currentLesson.quiz = [...this.cloneQuestions];
    this.showQuizDialog = true;
  }
  onDismissDialog() {
    this.showQuizDialog = false
    this.showScoreResult = false
    this.clearAnswer()
  }

  onSubmitQuiz() {
    // var result = confirm("Are you sure to submit?");
    // if (!result) {
    //   return;
    // }
    const lessonId = this.currentLesson.id
    const questions = this.currentLesson.quiz
    this.showSpinner = true
    console.log(questions);
    this.courseService.submitQuiz(lessonId,questions,this.course.id).subscribe(result=>{
      this.showSpinner = false
      if(result.error){
        // Has error
        this.toastr.error("Transaction failed")
        return;
      }
      console.log(result)
      // Success
      
      this.resultScore = result.score
      this.toastr.success("Summitted Quiz Successfully")
      this.showScoreResult = true
      if(!this.coursePass.submittedQuizLesson.includes(lessonId)){
        this.coursePass.submittedQuizLesson.push(lessonId)
        this.enableNextVideo()
      }
    })
  }

  clearAnswer(){
    this.currentLesson.quiz.map(q=>{
      q.studentAnswer = ""
      return q
    })
  }

  onRetryQuiz(){
    this.clearAnswer()
    this.currentLesson.quiz = [...this.cloneQuestions];
    this.showScoreResult = false
  }

  onShuffleQuiz(){
    this.clearAnswer();
    this.shuffleArray(this.currentLesson.quiz);
    this.showScoreResult = false
  } 

  onHideShowDesc(){
    this.hideDesc = !this.hideDesc
  }

   shuffleArray<T>(array: T[]): T[] {
    let currentIndex = array.length;
    let randomIndex: number;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;

  }

}
